import { render } from "./Ga.vue?vue&type=template&id=15735ead"
import script from "./Ga.vue?vue&type=script&lang=js"
export * from "./Ga.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/website/interhides/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"public/themes/default/resources/app/vue/cookie/analytic/Ga.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "15735ead"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('15735ead', __exports__)) {
    api.reload('15735ead', __exports__)
  }
  
  module.hot.accept("./Ga.vue?vue&type=template&id=15735ead", () => {
    api.rerender('15735ead', render)
  })

}


export default __exports__